'use strict';
var focusHelper = require('../components/focus');
var slickSlider = require('../thirdParty/slickSlider');
var giftMessage = require('../components/giftMessage');
var scrollMore = require('../components/quickViewScrollMore');
var pinchZoom = require('pinch-zoom-js/src/pinch-zoom');
var imagesLoaded = require('imagesloaded/imagesloaded');
var utils = require('../utils');
var carouselPrimarySelector = '.pdp-primary-images';
var carouselThumbnailSelector = '.product-image-container .product-thumbnails';
require('jquery-zoom/jquery.zoom.js');
var resizeTimerInternal;
var isResizeInitialized = false;
var lastEmbroideryOptionUrl = null;
var debounce = require('lodash/debounce');
var eGiftCard = require('./eGiftCard');

function isQuickView() {
    return $('.quick-modal.show').length > 0;
}

function isProductFinder() {
    return $('.js_product-finder-result').length > 0;
}

function isEmbroidery() {
    return $('.js_embroidery-quiz').length > 0;
}

/**
 * Initiate slick slider
 */
function setFinderSlickSlider() {
    if (!isProductFinder()) {
        return;
    }

    $('.mobile-zoom-icon').attr('src', $('.mobile-zoom-icon').data('finder'));
    $('.js_carousel-inner-actions, .js_carousel-progress').removeClass('d-none');
    $('.carousel-inner').each(function () {
        var $slider = $(this);

        if ($slider.hasClass('pdp-main-carousel')) {
            $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

                $('.js_carousel-progress')
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc);
            });
        }

        $slider.closest('.pdp-carousel-container').on('click keydown', '.js_slick-prev, .js_slick-next', function (e) {
            if (e.type === 'keydown' && !(/^(13|32)$/.test(e.which))) {
                // Neither the spacebar nor the enter key was pressed
                return;
            }

            if ($(this).hasClass('js_slick-prev')) {
                $slider.slick('slickPrev');
            } else {
                $slider.slick('slickNext');
            }
        });

        $slider.on('afterChange', function (event, slick) {
            var $container = slick.$slider.closest('.pdp-carousel-container');
            $container.find('.js_slick-prev').toggleClass('disabled', slick.$prevArrow.hasClass('slick-disabled'));
            $container.find('.js_slick-next').toggleClass('disabled', slick.$nextArrow.hasClass('slick-disabled'));
        });

        var $defaultValues = {
            arrows: true,
            fade: false,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: 1.5,
            speed: 400,
            accessibility: true
        };
        slickSlider.init($slider, $defaultValues);
    });
}

/**
 * Resize carousels
 */
function resizeCarousels() {
    if (isProductFinder() || window.isGfore) {
        return;
    }

    $(carouselPrimarySelector).each(function () {
        if ($(this).closest('.product-quickview').length > 0) return;
        var selector = $('.carousel-inner', this);
        if (selector.length) {
            if ($(window).outerWidth() > 992) {
                if (selector.hasClass('slick-initialized')) {
                    selector.slick('unslick');
                }
            } else if (selector.hasClass('slick-initialized')) {
                selector.slick('resize');
            } else {
                var $defaultValues = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    infinite: true,
                    fade: false,
                    speed: 400
                };
                var $responsiveValues = {
                    dots: true
                };
                slickSlider.init(selector, $defaultValues, $responsiveValues);
            }
        }
    });

    $(carouselThumbnailSelector).each(function () {
        if ($(this).closest('.product-quickview').length > 0) return;
        var selector = $('.slider-nav', this);
        if (selector.length && selector.hasClass('slick-initialized')) {
            selector.slick('resize'); // $($(selector)[0]) hasClass('slick-initialized')
        }
    });
}

/**
 * Initiate slick slider
 * @param {boolean} scrollTop - Flag to indicate if quick view is open
 */
function setSlickSlider(scrollTop) {
    if (isProductFinder()) {
        return;
    }

    $(document).on('click touchstart', '.pdp-primary-images .viewmore a', function (e) {
        e.preventDefault();
        const viewmore = $(this).attr('data-viewmore');
        const viewmless = $(this).attr('data-viewless');

        $('.product-detail .carousel-item').toggleClass('show');
        $(this).toggleClass('active');
        window.viewProductFlag = false;
        if ($(this).hasClass('active')) {
            $(this).text(viewmless);
            window.viewProductFlag = true;
        } else {
            $(this).text(viewmore);
        }
    });

    // Accessibility: Global afterChange handler for ALL slick carousels to manage focus
    $(document).on('afterChange', '.slick-slider, .slick-initialized', function (event, slick, currentSlide) { // eslint-disable-line no-unused-vars
        var wasKeyboardActivated = $(this).data('keyboard-activated');

        if (wasKeyboardActivated) {
            // Clear the flag
            $(this).data('keyboard-activated', false);

            // Get the active slide
            var $activeSlide = $(slick.$slides[currentSlide]);

            if ($activeSlide.length) {
                // Try to find the product title/heading first (most semantically meaningful)
                var $focusTarget = $activeSlide.find('h1, h2, h3, h4, h5, h6, .product-name, .product-title, .pdp-link a').first();

                // If no heading, try product link
                if (!$focusTarget.length) {
                    $focusTarget = $activeSlide.find('a.link, a[href], .product-tile a').first();
                }

                // If still nothing, try any focusable element
                if (!$focusTarget.length) {
                    $focusTarget = $activeSlide.find('a, button, [href]').not('.shop-the-look-gallery-cta').first();
                }

                // Last resort: use the slide container itself
                if (!$focusTarget.length) {
                    $focusTarget = $activeSlide.find('.grid-tile, .product-tile').first();
                }

                if (!$focusTarget.length) {
                    $focusTarget = $activeSlide;
                }

                // Make sure element is focusable
                if (!$focusTarget.attr('tabindex') && !$focusTarget.is('a, button, [href]')) {
                    $focusTarget.attr('tabindex', '-1');
                }

                // Move focus to the newly revealed content
                var focusElement = $focusTarget.get(0);
                if (focusElement) {
                    focusElement.focus();
                }
            }
        }
    });

    // Accessibility: Add keyboard support for ALL carousel navigation arrows (recommendations, PDP, etc)
    $(document).on('click keydown', '.prev-arrow, .next-arrow, .slide-arrow', function (e) {
        if (e.type === 'keydown' && !(/^(13|32)$/.test(e.which))) {
            // Neither the spacebar nor the enter key was pressed
            return;
        }

        // The parent might BE the slick carousel itself (for recommendations)
        var $carousel = $(this).parent();

        // Check if parent is the slick carousel
        if (!$carousel.hasClass('slick-slider') && !$carousel.hasClass('slick-initialized')) {
            // If not, try to find carousel-inner as sibling
            $carousel = $(this).siblings('.carousel-inner');

            // Or try within parent
            if (!$carousel.length) {
                $carousel = $(this).parent().find('.carousel-inner');
            }

            // Or try in closest container
            if (!$carousel.length) {
                var $container = $(this).closest('.pdp-main-carousel, .primary-images');
                $carousel = $container.find('.carousel-inner');
            }
        }

        if ($carousel.length && ($carousel.hasClass('slick-initialized') || $carousel.hasClass('slick-slider'))) {
            // Mark that this was a keyboard activation
            // IMPORTANT: Only set to true on keydown, never set to false on click
            // (because Enter key triggers both keydown AND click events)
            var isKeyboard = e.type === 'keydown';

            if (isKeyboard) {
                $carousel.data('keyboard-activated', true);
            } else {
                // On click event, only trigger navigation if keyboard flag is not already set
                var alreadyKeyboard = $carousel.data('keyboard-activated');

                if (alreadyKeyboard) {
                    return; // Skip - the keydown already triggered navigation
                }
            }

            if ($(this).hasClass('prev-arrow')) {
                $carousel.slick('slickPrev');
            } else {
                $carousel.slick('slickNext');
            }
        }
    });

    if ($(window).outerWidth() > 992) {
        $(carouselPrimarySelector).each(function () {
            if ($(this).closest('.product-quickview').length > 0) return;
            var selector = $('.pdp-primary-images .carousel-inner', this);
            selector.slick('unslick');
        });
    } else {
        // PDP Primary Images
        $(carouselPrimarySelector).each(function () {
            if ($(this).closest('.product-quickview').length > 0) return;
            var selector = $('.carousel-inner', this);
            var $defaultValues = {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: true,
                fade: false,
                speed: 400
            };
            var $responsiveValues = {
                dots: true
            };
            slickSlider.init(selector, $defaultValues, $responsiveValues);
            selector.on('setPosition', function () {
                var realHeight = selector.outerHeight();
                var $wrapper = selector.closest('.primary-images');
                var minHeight = $wrapper.length ? parseInt($wrapper.css('min-height'), 10) || 0 : 0;

                if (minHeight && realHeight >= minHeight) {
                    $wrapper.css('min-height', '');
                }

                if (isEmbroidery() && scrollTop && $('.embroidery-product-quickview').length > 0) {
                    setTimeout(() => {
                        $('.embroidery-product-quickview').scrollTop(scrollTop);
                    }, 100);
                }
            });

            if ($(window).outerWidth() > 992) {
                selector.slick('unslick');
            }
        });
    }
}

/**
* Finding touch device
* @returns {boolean} - Flag to indicate if device is touch screen or not
*/
function isTouchDevice() {
    return (('ontouchstart' in document.documentElement) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

/**
* Zoom functionality on PDP
*/
function loadZoom() {
    if (isQuickView() && !isEmbroidery()) {
        return;
    }

    var isMobileView = $(window).outerWidth() < 992;
    var touch = isTouchDevice();

    /**
     * TOUCH / PINCH ZOOM
     */
    if (touch) {
        if (isMobileView) {
            window.pinchZoomObj = [];
            var $el = $('.gallery-modal .modal-mobile-img');

            imagesLoaded('.gallery-modal .modal-mobile-img')
                .off('always')
                .on('always', function () {
                    $el.each(function () {
                        /* eslint-disable */
                        window.pinchZoomObj.push(new pinchZoom.default(this, {}));
                    });
                });
        } else {
            imagesLoaded('.carousel-item.zoom img')
                .off('always')
                .on('always', function () {
                    $('.carousel-item.zoom img').each(function () {
                        new pinchZoom.default(this, {});
                    });
                    var height = 0;
                    setTimeout(function () {
                        $('.carousel-item.zoom .pinch-zoom-container').each(function (idx, elem) {
                            if (!height && $(elem).height()) {
                                height = $(elem).height();
                            }
                            if (height && !$(elem).height()) {
                                $(elem).height(height)
                            }
                        });
                    }, 1000);
                });
        }
    }

    /**
     * CLICK / DESKTOP ZOOM
     * Always enabled so hybrid devices work
     */
    $('.carousel-item.zoom', carouselPrimarySelector).each(function () {
        $(this).off('click keydown').on('click keydown', function (e) {
            if (e.type === 'keydown' && !(/^(13|32)$/.test(e.which))) {
                return;
            }

            if ($(this).hasClass('zoomDesk')) {
                $(this).removeClass('zoomDesk');
            } else {
                $(this).addClass('zoomDesk');
            }

            $(this).siblings().removeClass('zoomDesk');

            var $elem = $('img.product-carousel-img-main', this);
            var dataZoomSrc = $elem.data('zoom-src');

            if (dataZoomSrc !== undefined) {
                $(this).zoom({
                    magnify: 1,
                    url: dataZoomSrc
                });
            }
        });
    });
}

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint, $initialSlide) {
    if (!isEmbroidery()) {
        var slider = $($slidername);
        var settings = {
            mobileFirst: true,
            slidesToShow: 1,
            initialSlide: Number($initialSlide),
            dots: $dots,
            arrows: $arrows,
            draggable: false,
            touchMove: false,
            swipeToSlide: false,
            swipe: false,
            responsive: [
                {
                    breakpoint: $breakpoint,
                    settings: 'unslick'
                }
            ]
        };
        slider.slick('unslick');
        slider.slick(settings);
        slickSlider.setupAccessibility(slider);

        $(window).on('resize', debounce(function () {
            if ($(window).outerWidth() > $breakpoint) {
                return;
            }
            if (!slider.hasClass('slick-initialized')) {
                slider.slick(settings);
                slickSlider.setupAccessibility(slider);
            }
        }, 200));
    }

    $('#modalImage .gallery-carousel').on('beforeChange', function () {
        if (window.matchMedia('(orientation: landscape)').matches) {
            zoomImgLandscape();
        } else if (window.matchMedia('(orientation: portrait)').matches) {
            zoomImgPortrait();
        }
    });
}

// Mobile Only Slider

function zoomImgPortrait() {
    window.pinchZoomObj.forEach((po) => {
        po.zoomFactor = 2;
        po.update();
    });
    setTimeout(() => {
        window.pinchZoomObj.forEach((po) => {
            po.offset.x = window.innerWidth / 2;
            po.offset.y = window.innerHeight / 2;
            po.update();
        });
    }, 0);
}

function zoomImgLandscape() {
    window.pinchZoomObj.forEach((po) => {
        po.zoomFactor = 1;
        po.update();
    });
    setTimeout(() => {
        window.pinchZoomObj.forEach((po) => {
            po.offset.x = 10;
            po.offset.y = window.innerHeight / 30;
            po.update();
        });
    }, 0);
}

$('body').on('shown.bs.modal', '#modalImage', function () {
    $('#launcher').addClass('d-none');
    var selectedelement = $('.carousel-inner').find('.slick-active').attr('data-slick-index');
    mobileOnlySlider('#modalImage .gallery-carousel', false, true, 992, selectedelement);
    if (window.innerHeight < window.innerWidth) {
        var imgHeight = $('.gallery-modal .modal-mobile-img img').attr('height');
        $('.gallery-modal .carousel-item').css('height', imgHeight + 'px');
    } else {
        $('.gallery-modal .carousel-item').css('height', 'auto');
    }

    if (window.matchMedia('(orientation: portrait)').matches) {
        zoomImgPortrait();
    } else if (window.innerHeight < window.innerWidth) {
        zoomImgLandscape();
    }

    $(window).on('orientationchange resize', function () {
        if (window.matchMedia('(orientation: landscape)').matches) {
            zoomImgLandscape();
        } else if (window.matchMedia('(orientation: portrait)').matches) {
            zoomImgPortrait();
        }
    });

    $('.product-carousel-img-main').on('pointermove', function () {
        $('.pinch-zoom-text').addClass('fade');
    });
    $('.product-carousel-img-main').on('pointerleave', function () {
        $('.pinch-zoom-text').removeClass('fade');
    });
});

$('body').on('hide.bs.modal', '#modalImage', function () {
    var selectedelementgallery = $('.gallery-carousel.carousel-inner').find('.slick-active').attr('data-slick-index');
    if (!isEmbroidery()) {
        $('.carousel-inner').slick('slickGoTo', selectedelementgallery);
    }
    $('#launcher').removeClass('d-none');
});

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if (($('#quickViewModal').hasClass('show') || $('#editProductModal').hasClass('show'))
        && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').data('product-upc');
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    return $($el).closest('.product-detail').find('.quantity-select');
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val() || 1;
}

function getAssistiveText(attrValue, msgs) {
    var parts = [];
    // if (attrValue.selected) parts.push(msgs.assistiveSelectedText);
    if (attrValue.selectable === false) parts.push(msgs.assistiveDisabledText);
    return parts.join(' ');
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();
        var parentCategory = $swatchButton.attr('data-parent-category');

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            if (attr.id !== 'color') {
                $swatchButton.closest('.product-attribute').find('.selected-attr').html($swatchButton.find('.swatch-value').data('attr-title'));
            }
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
            $swatchButton.addClass('selected').attr('aria-checked', 'true');
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
            $swatchButton.removeClass('selected').attr('aria-checked', 'false');
        }

        if (attrValue.selected && isEmbroidery() && attr.id === 'color') {
            $swatchButton.closest('.product-attribute').find('.selected-attr').html($swatchButton.find('.swatch-value').data('attr-title').toLowerCase());
        }

        if (attrValue.url && isEmbroidery() && parentCategory) {
            $swatchButton.attr('data-url', attrValue.url + '&embroideryProduct=true' + '&cgid=' + parentCategory);
        } else if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }
        $attrValue.closest('.swatch-attribute').toggleClass('unorderable', !attrValue.selectable);
        $attrValue.closest('.swatch-attribute').addClass(!attrValue.selectable ? 'unorderable' : '');
        if (attrValue.selected) {
            if ($swatchButton.hasClass('unorderable')) {
                $swatchButton.closest('.product-attribute').find('.selected-attr').addClass('unorder');
            } else {
                $swatchButton.closest('.product-attribute').find('.selected-attr').removeClass('unorder');
            }
        }
        var $assist = $swatchButton.find('.selected-assistive-text');
        if ($assist.length) {
            $assist.text(getAssistiveText(attrValue, msgs));
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    attrs.forEach(function (attr) {
        processSwatchValues(attr, $productContainer, msgs);
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    if (!response.product.availability && isEmbroidery()) return;
    var availabilityMessages = response.product.availability.messages;
    if (response.product.readyToOrder && !response.product.isEGiftCard) {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<p class="mb-0">' + message + '</p>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });

    if (response.product.available) {
        $('.availabilityMsg', response.$productContainer).removeClass('out-of-stock');
    } else {
        $('.availabilityMsg', response.$productContainer).addClass('out-of-stock');
    }

    if (isEmbroidery()) {
        $('.step-forward-button').toggleClass('disabled', !response.product.available);
        $('.step-forward-button').prop('disabled', !response.product.available);
    }
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer, $logoChoice) {
    if (optionsHtml && optionsHtml.includes('embroideryProductOptions') && !isEmbroidery()) return;
    // Update options
    if (optionsHtml) $productContainer.find('.product-options').html(optionsHtml);
    $productContainer.trigger('options:updated');
    if ($logoChoice) {
        $('.js_options-carousel-container').removeClass('d-none');
    }
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images along with related information
 * @param {Object[]} zoomImageUrls - Array of xlarge product images along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {boolean} isLastSizeLarge - true if last product image should be rendered large on desktop
 */
function createCarousel(imgs, zoomImageUrls, $productContainer, isLastSizeLarge) {
    var carousel = $productContainer.find(carouselPrimarySelector).not('.quickview-desktop-carousel');
    var placeholderURL = $productContainer.find('span[data-lazy-placeholder]').eq(0).attr('data-lazy-placeholder');
    var h = carousel.height();
    carousel.css('min-height', h + 'px');
    $(carousel).carousel('dispose');

    if (carousel.hasClass('slick-initialized')) {
        carousel.slick('unslick');
    } else if (carousel.find('.carousel-inner').hasClass('slick-initialized')) {
        carousel.find('.carousel-inner').slick('unslick');
    }

    $(carousel).empty().append('<div class="carousel-inner"></div><button type="button" class="slide-arrow prev-arrow slick-arrow d-none" data-slide="prev" aria-label="Previous slide"> <span class="svgicon svg-chevron svg-chevron-dims cs-svg-icon-wrapper"> <svg> <use href="#carousel-left-arrow"></use> </svg> </span><span class="sr-only">Previous</span> </button><button type="button" class="slide-arrow next-arrow slick-arrow d-none" data-slide="next" aria-label="Next slide"> <span class="svgicon svg-chevron svg-chevron-dims cs-svg-icon-wrapper"> <svg> <use href="#carousel-left-arrow"></use> </svg> </span><span class="sr-only">Next</span> </button>');

    for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].isVideo) {
            var source = imgs[i].url ? 'data-cld-public-id="' + imgs[i].url + '" ' : '';
            var poster = imgs[i].thumbnailUrl ? 'poster="' + imgs[i].thumbnailUrl + '" ' : '';
            var position = imgs[i].position ? 'data-position="' + imgs[i].position + '" ' : '';
            var cloudName = imgs[i].cloudName ? 'data-cloud-name="' + imgs[i].cloudName + '" ' : '';
            var audio = 'data-has-audio="' + imgs[i].hasAudio + '" ';
            $('<div class="carousel-item zoom pdp-video" role="option" tabindex="-1"><video id="pdp-cloudinary-video-ajax-' + imgs[i].position.toString() + '" class="cld-video-player" width="100%" ' + source + poster + position + cloudName + audio + '></video></div>').appendTo($(carousel).find('.carousel-inner'));
        } else if (isQuickView()) {
            $('<div class="carousel-item" role="option"><img class="product-carousel-img-main d-block img-fluid" src="' + imgs[i].url + '" data-src="' + imgs[i].url + '" data-src-error="' + placeholderURL + '" alt="' + imgs[i].alt + ' image number ' + parseInt(Number(imgs[i].index) + 1, 10) + '" /></div>').appendTo($(carousel).find('.carousel-inner'));
        } else {
            var extraClassNames = '';
            if (imgs.length === 1) extraClassNames += 'itemsOne';
            if (isLastSizeLarge && imgs.length % 2 !== 0 && imgs.length === (i + 1)) extraClassNames += ' oddItems';
            $('<div class="carousel-item zoom ' + extraClassNames + '" role="option" tabindex="-1"><img class="product-carousel-img-main d-block img-fluid" src="' + imgs[i].url + '" data-src="' + imgs[i].url + '" data-zoom-src="' + zoomImageUrls[i].url + '" data-src-error="' + placeholderURL + '" alt="' + imgs[i].alt + '-' + parseInt(Number(imgs[i].index) + 1, 10) + '" /></div>').appendTo($(carousel).find('.carousel-inner'));
        }
    }
    if (!isQuickView()) {
        loadZoom();
    }
    $($(carousel).find('.carousel-item')).first().addClass('active');
    if (imgs.length === 1) {
        $($(carousel).find('.carousel-indicators, a[class^="carousel-control-"]')).detach();
    }
    if ($(window).width() < 992) {
        $(carousel).carousel();
    }
}

/**
 * Dynamically creates slick alt carousel from response containing images
 * @param {Object[]} imgs - Array of large product images, along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAltCarousel(imgs, $productContainer) {
    var thumbnails = $productContainer.find('.product-thumbnails');
    var $oldCarousel = thumbnails.find('.slider-nav');
    var $prevSlick = thumbnails.find('.slick-prev-thumb');
    var $nextSlick = thumbnails.find('.slick-next-thumb');
    var placeholderURL = $productContainer.find('span[data-lazy-placeholder]').eq(0).attr('data-lazy-placeholder');
    var mainHeight = $productContainer.find('.primary-images').height();

    if (imgs.length > 1 && $(window).width() < 992) {
        if ($oldCarousel.hasClass('slick-initialized')) {
            $oldCarousel.slick('destroy');
        }
        // 96 x 131
        thumbnails.addClass('d-flex').removeClass('d-none');
        thumbnails.height(mainHeight);
        thumbnails.empty()
            .append('<div class="slider-nav order-2 p-0"></div>')
            .append($prevSlick)
            .append($nextSlick);
        for (var i = 0; i < imgs.length; i++) {
            // Preload images
            var image = new Image();
            image.onload = function () {
                thumbnails.find('.slider-nav').trigger('thumbnailcarouselreinit');
            };
            image.src = imgs[i].url;

            var toAppend = '<div class="thumb"><img class="productthumbnail img-fluid" src="' + imgs[i].url + '" data-src="' + imgs[i].url + '" data-src-error="' + placeholderURL + '" alt="' + imgs[i].alt + '"/></div>';
            thumbnails.find('.slider-nav').append(toAppend);
        }
        setSlickSlider();
    } else {
        thumbnails.addClass('d-none').removeClass('d-flex');
        thumbnails.height(mainHeight);
    }
}

/**
 * Loads javascript for PDP videos
 */
function loadPDPVideos() {
    var isMobile = $(window).width() < 992;
    var cldPlayers = [];

    $('video.cld-video-player').each(function () {
        if ($(this).closest('.quick-modal').length > 0) {
            var quickModalID = $(this).closest('.quick-modal').attr('id');
            $(this).attr('id', $(this).attr('id') + '-' + quickModalID);
        }
        if ($(this).closest('.quickview-mobile-carousel').length > 0) $(this).attr('id', $(this).attr('id') + '-mobile');
        if ($(this).closest('.quickview-desktop-carousel').length > 0) $(this).attr('id', $(this).attr('id') + '-desktop');

        var cldPlayerID = $(this).prop('id');
        if (cldPlayerID) {
            var cloudName = $(this).data('cloud-name');
            var position = $(this).data('position');
            position = position ? parseInt(position, 10) : position;

            var player = cloudinary.videoPlayer(cldPlayerID, {
                cloudName: cloudName,
                controls: true,
                muted: true,
                autoplayMode: (!isMobile || position === 1) ? 'on-scroll' : 'never',
                playsinline: true,
                aspectRatio: '880:990',
                showLogo: false,
                loop: true
            });

            player.on('play', function () {
                player.videojs.autoplayOnScroll();
            });

            player.on('loadeddata', function () {
                if (player.duration() >= 20) {
                    player.loop(false);
                }
            });

            cldPlayers.push(player);
        }
    });

    $('.pdp-main-carousel.slick-slider').on('afterChange', function (event, slick, currentSlide) { // eslint-disable-line no-unused-vars
        var activeCloudinaryVideoPlayerID = null;
        var $activeCarouselItem = $(this).find('.slick-active').find('.carousel-item');
        if ($activeCarouselItem && $activeCarouselItem.length && $activeCarouselItem.hasClass('pdp-video')) {
            activeCloudinaryVideoPlayerID = $activeCarouselItem.find('.cld-video-player').prop('id');
        }

        cldPlayers.forEach(player => {
            if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                player.play();
            } else {
                player.pause();
            }
        });
    });

    var isTouchClick = null;
    var $disabledSlickSlider = null;
    $('.pdp-video').on('touchstart', function (event) {
        isTouchClick = true;


        var isVolumeControl = false;
        if (event && event.target) {
            isVolumeControl = $(event.target).closest('.vjs-volume-panel').length > 0;
        }

        if (isVolumeControl) {
            var $slickSlider = $(event.target).closest('.slick-slider');
            if ($slickSlider && $slickSlider.length) {
                $disabledSlickSlider = $slickSlider;
                $slickSlider.slick('slickSetOption', 'accessibility', false);
                $slickSlider.slick('slickSetOption', 'draggable', false);
                $slickSlider.slick('slickSetOption', 'swipe', false);
                $slickSlider.slick('slickSetOption', 'touchMove', false);
            }
        }
    });
    $('.pdp-video').on('touchmove', function () {
        isTouchClick = false;
    });
    $('.pdp-video').on('touchend', function (event) {
        var isVolumeControl = false;
        if (event && event.target) {
            isVolumeControl = $(event.target).closest('.vjs-volume-panel').length > 0;
        }

        if (isTouchClick && !isVolumeControl) {
            var activeCloudinaryVideoPlayerID = $(this).find('.cld-video-player').prop('id');
            cldPlayers.forEach(player => {
                if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                    if (player.videojs.paused()) {
                        player.play();
                    } else {
                        player.pause();
                    }
                }
            });
        }

        if ($disabledSlickSlider) {
            $disabledSlickSlider.slick('slickSetOption', 'accessibility', true);
            $disabledSlickSlider.slick('slickSetOption', 'draggable', true);
            $disabledSlickSlider.slick('slickSetOption', 'swipe', true);
            $disabledSlickSlider.slick('slickSetOption', 'touchMove', true);
            $disabledSlickSlider = null;
        }
    });

    $('.pdp-video-pause-button').on('click', function () {
        var activeCloudinaryVideoPlayerID = $(this).siblings('.cld-video-player').prop('id');
        cldPlayers.forEach(player => {
            if (player.videoElement && player.videoElement.playerId === activeCloudinaryVideoPlayerID) {
                player.pause();
            }
        });
    });
}

/**
 * updates explicit product set recommendations on PDP
 * @param {Object} colorCode - product selected color code string
 */
function updateExplicitProductSetRecommender(colorCode) {
    var url = $('.pdp-explicit-product-set-recommendations').attr('data-url');
    if (colorCode && url) {
        var queryString = '?pid=' + $('.product-detail').data('pid') + '&colorCode=' + colorCode;
        $.ajax({
            url: url + queryString,
            method: 'GET',
            success: function (response) {
                $('.pdp-explicit-product-set-recommendations').replaceWith(response);
            }
        });
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 * @param {boolean} reinitCarousel - Color was changes, reinit carousel.
 */
function handleVariantResponse(response, $productContainer, reinitCarousel) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    if (reinitCarousel && !(isProductFinder() || isEmbroidery())) {
        // Update primary images
        var primaryImageUrls = response.product.images['pdp-main-desktop'];
        var zoomImageUrls = response.product.images['pdp-main-zoom'];
        var $carouselTarget = $productContainer.closest('.default-quick-view-dialog');
        if (!$carouselTarget.length) {
            $carouselTarget = $productContainer;;
        }

        var isLastImgSizeLarge = response && response.isLastSizeLarge;

        if (!response.product.imageCarouselHtml || response.product.imageCarouselHtml.length === 0) {
            createCarousel(primaryImageUrls, zoomImageUrls, $carouselTarget, isLastImgSizeLarge);
        }

        if (!isQuickView()) {
            // Update alternative images carousel
            var altImagesUrl = response.product.images['pdp-thumbnail-desktop'];
            updateAltCarousel(altImagesUrl, $productContainer);
        }
    }

    // common.lazyLoad();
    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : ($productContainer.closest('.modal-content').find('.prices .price').length
                ? $productContainer.closest('.modal-content').find('.prices .price')
                : $('.prices .price'));
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }
    if (response.product && isEmbroidery()) {
        if ($('.embroidery-product-quickview').attr('selected-logo') === 'false' && response.product.initialPriceFormatted) {
            $('.embroidery-starting-price').html(response.product.initialPriceFormatted);
        } else if (response.product.price.sales) {
            $('.embroidery-starting-price').html(response.product.price.sales.formatted);
        }
    }

    var $quickViewPDPLink = $productContainer.find('.pdp-link');
    if ($quickViewPDPLink && $quickViewPDPLink.length > 0 && response.urls && response.urls.product) {
        $quickViewPDPLink.attr('href', response.urls.product);
    }
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if (!($productContainer.parent('.bonus-product-item').length > 0)) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            var ariaSelected = isQuickView() ? ' aria-selected="' + (quantity.selected ? 'true' : 'false') + '"' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                selected + ariaSelected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * Updates the Fit DOM elements post Ajax call
 * @param {string} productFitHtml - The HTML representing the product fit
 */
function updateProductFit(productFitHtml) {
    var $productFit = $('.js-product-fit');
    if (productFitHtml) {
        $productFit
            .removeClass('d-none')
            .find('.js-fit-info')
            .empty()
            .html(productFitHtml);
    } else {
        $productFit.addClass('d-none');
    }
}


function isAllowedKeys(e) {
    // Spacebar or enter key
    return e.type === 'keydown' && !(/^(13|32)$/.test(e.which));
}

/**
 * hides or shows the new color text based on the currently selected color
 * @param {jQuery} $colorButton - the selected color button
 * @param {jQuery} $newTextDiv - the new color text div
 */
function toggleNewColorText($colorButton, $newTextDiv) {
    var hideTextDiv = !$colorButton.hasClass('is-new') || $colorButton.hasClass('unorderable');
    $newTextDiv.toggleClass('d-none', hideTextDiv);
}

/**
 * hides or shows the final sale text based on the currently selected color
 * @param {jQuery} $colorButton - the selected color button
 * @param {jQuery} $newTextDiv - the final sale text div
 */
function toggleFinalSaleText($colorButton, $newTextDiv) {
    var hideTextDiv = !$colorButton.hasClass('is-final-sale') || $colorButton.hasClass('unorderable');
    $newTextDiv.toggleClass('d-none', hideTextDiv);
}

/**
 * updates the product gallery asset content on the PDP
 * @param {Object} product - product object from the response
 * @param {jQuery} $productContainer - DOM container for current product
 */
function updateProductGalleryAsset(product, $productContainer) {
    var $productGalleryAssetContainer = $('.product-gallery-asset-container', $productContainer);
    if (product && $productGalleryAssetContainer && $productGalleryAssetContainer.length) {
        if (product.productGalleryAsset && product.productGalleryAsset.html && product.productGalleryAsset.id) {
            if ($productGalleryAssetContainer.data('asset-id') !== product.productGalleryAsset.id) {
                $productGalleryAssetContainer.html(product.productGalleryAsset.html);
                $productGalleryAssetContainer.data('asset-id', product.productGalleryAsset.id);
            }
        } else {
            $productGalleryAssetContainer.empty();
            $productGalleryAssetContainer.data('asset-id', null);
        }
    }
}

function onQuickViewImagesLoaded(element, callback) {
    let images = element ? element.querySelectorAll('img') : [];
    let imagesToLoad = images.length;
    let imagesLoaded = 0;

    if (imagesToLoad === 0) {
        callback(); // No images, trigger immediately
        return;
    }

    function imageLoaded() {
        imagesLoaded++;
        if (imagesLoaded === imagesToLoad) {
            callback();
        }
    }

    images.forEach(img => {
        if (img.complete) {
            // If the image is already loaded (e.g., from cache),
            // call imageLoaded() immediately.
            imageLoaded();
        } else {
            img.addEventListener('load', imageLoaded);
            img.addEventListener('error', imageLoaded); // Consider error case
        }
    });

    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
        setTimeout(callback, 300);
    }
}

function handleQuickViewImagesLoaded() {
    var $carouselToRemove = $('#quickViewModal, #editProductModal').find('.modal-float .parent-image-carousel.js-remove, .quickview-mobile-carousel .parent-image-carousel.js-remove');
    var $newCarousel = $('#quickViewModal, #editProductModal').find('.modal-float .parent-image-carousel.js-new, .quickview-mobile-carousel .parent-image-carousel.js-new');
    $carouselToRemove.remove();
    $newCarousel.removeClass('invisible').removeClass('js-new');
    $('#quickViewModal, #editProductModal').find('.modal-float').removeClass('d-none');
    $('#quickViewModal, #editProductModal').each(function () {
        // Re-measured on every size change, not once (see quickViewScrollMore)
        scrollMore.watch($(this));
    });
    $.spinner().stop();
}

function setCustomEGiftCardDesign($productContainer) {
    var egcAttrContainer = $productContainer.find('.e-gift-card-attribute');
    if (egcAttrContainer.length) {
        if (egcAttrContainer.find('.egift-swatch-value.color-value.selected').length) {
            $productContainer.find('.js-egc-selected-design').val(egcAttrContainer.find('.egift-swatch-value.color-value.selected').data('attr-value'));
        }
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {element} $clickedColor - the color selected by user
 */
function attributeSelect(selectedValueUrl, $productContainer, $clickedColor, $logoChoice, selectedOption, selectionType) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        var reinitCarousel = $clickedColor !== undefined;
        var reinitQuickviewModalFloatImages = false;
        if (isEmbroidery()) {
            selectedValueUrl = utils.appendParamToURL(selectedValueUrl, 'isCustomEmbroidery', 'true');
            if (lastEmbroideryOptionUrl === selectedValueUrl) return;
            lastEmbroideryOptionUrl = selectedValueUrl;
        }

        if (isQuickView()) {
            selectedValueUrl = utils.appendParamToURL(selectedValueUrl, 'isQuickView', 'true');
        } else {
            selectedValueUrl = utils.appendParamToURL(selectedValueUrl, 'isQuickView', 'false');
        }

        if (selectionType !== 'quantitySelect') {
            selectedValueUrl = utils.appendParamToURL(selectedValueUrl, 'quantity', '1');
            selectedValueUrl = selectedValueUrl.replace(/([?&])quantity=[^&]*/i, '$1quantity=1');
        }

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                var qvTop = $('.embroidery-product-quickview').scrollTop();
                reinitQuickviewModalFloatImages = reinitCarousel && data.product.imageCarouselHtml.length && $productContainer.hasClass('product-quickview') && !$productContainer.hasClass('embroidery-product-quickview');

                handleVariantResponse(data, $productContainer, reinitCarousel);
                updateOptions(data.product.optionsHtml, $productContainer, $logoChoice);

                updateQuantities(data.product.quantities.slice(0, data.product.availability.ats), $productContainer);

                setCustomEGiftCardDesign($productContainer);

                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                if ($clickedColor) {
                    updateProductFit(data.product.productFit);
                    $('.selected-attr.colorPriceGroup').html('');
                    $clickedColor.siblings('.color').find('.selected-attr').html('');
                    var attributeParentContainer = $productContainer.find('.color-attribute.selected').parent();
                    if (!attributeParentContainer.prevAll('.color').length && attributeParentContainer.parent().prevAll('.color').length) {
                        attributeParentContainer = attributeParentContainer.parent();
                    }
                    if (isEmbroidery()) {
                        $productContainer.find('.color-attribute.selected').closest('.product-attribute').find('.selected-attr').html($clickedColor.find('.color-value').data('attr-title').toString().toLowerCase());
                    } else {
                        if (data.product.isEGiftCard) {
                            attributeParentContainer.prevAll('span:first').find('.selected-attr').html($clickedColor.find('.color-value').data('attr-title').toString());
                        } else {
                            attributeParentContainer.prevAll('span:first').find('.selected-attr').html($clickedColor.find('.color-value').data('attr-title').toString().toUpperCase());
                        }

                    }
                    $('.new-color-text', $productContainer).addClass('d-none');
                    $('.final-sale-text', $productContainer).addClass('d-none');
                    toggleNewColorText($clickedColor, attributeParentContainer.prevAll('span:first').find('.new-color-text'))
                    toggleFinalSaleText($clickedColor, attributeParentContainer.prevAll('span:first').find('.final-sale-text'))

                    updateProductGalleryAsset(data.product, $productContainer);
                }
                $productContainer.find('.quantity-select').removeAttr('disabled');

                var $priceElem = $('.price', $productContainer).length
                    ? $('.price', $productContainer)
                    : ($productContainer.closest('.modal-content').find('.price').length
                        ? $productContainer.closest('.modal-content').find('.price')
                        : $('.price'));

                if (data.product.price.type === 'salePriceRange') {
                    $priceElem.addClass('sale-price-group');
                } else {
                    $priceElem.removeClass('sale-price-group');
                }

                if (reinitQuickviewModalFloatImages) {
                    $('.viewmore').remove();
                    var $parentImageCarousel = $productContainer.hasClass('product-quickview') && !$productContainer.hasClass('embroidery-product-quickview')
                        ? $productContainer.closest('.modal-dialog').find('.modal-float .parent-image-carousel, .quickview-mobile-carousel .parent-image-carousel')
                        : $productContainer.find('.parent-image-carousel');
                    $parentImageCarousel.addClass('js-remove');

                    var $newImageCarousel = $(data.product.imageCarouselHtml);
                    $newImageCarousel.addClass('js-new').addClass('invisible');
                    $newImageCarousel.insertAfter($parentImageCarousel);
                    onQuickViewImagesLoaded($productContainer.closest('.modal-dialog').find('.modal-float').get(0), handleQuickViewImagesLoaded);
                } else if (reinitCarousel && data.product.imageCarouselHtml.length) {
                    $('.viewmore').remove();
                    var $parentImageCarousel = $productContainer.hasClass('product-quickview') && !$productContainer.hasClass('embroidery-product-quickview')
                        ? $productContainer.closest('.modal-dialog').find('.modal-float .parent-image-carousel, .quickview-mobile-carousel .parent-image-carousel')
                        : $productContainer.find('.parent-image-carousel');
                    $parentImageCarousel.replaceWith(data.product.imageCarouselHtml);
                }

                if ($(window).width() < 992 && !isQuickView()) {
                    setSlickSlider(qvTop);
                }

                if (!$productContainer.hasClass('embroidery-product-quickview')) loadPDPVideos();

                setFinderSlickSlider();

                if (isQuickView()) {
                    $('.viewmore').remove();
                    if (isEmbroidery()) {
                        $('body').trigger('edit:slider');
                    } else {
                        $('body').trigger('quickview:change');
                    }
                }

                if (window.viewProductFlag) {
                    var viewButton = $('body').find('.pdp-primary-images .viewmore a');
                    var viewLess = viewButton.attr('data-viewless');
                    viewButton.addClass('active');
                    $('.product-detail .carousel-item').addClass('show');
                    viewButton.text(viewLess);
                }

                loadZoom();

                if (data.gtmDataLayer) {
                    window.dataLayer = window.dataLayer || [];
                    for (var ind = 0; ind < data.gtmDataLayer.length; ind++) {
                        window.dataLayer.push(data.gtmDataLayer[ind]);
                    }
                }

                if (data && data.product && data.product.priceHistoryHtml) {
                    $('.price-history-container').replaceWith(data.product.priceHistoryHtml);
                } else {
                    $('.price-history-container').empty();
                }
                $('.color-change').removeClass('color-change');
                $(document)
                    .trigger('embroidery:initLogoSlider')
                    .trigger('embroidery:goToCurrentLogoSlide')
                    .trigger('custom:embroidery:show:available:options');

                if (selectedOption) {
                    $('.selected-option-attr').text(selectedOption);
                    $('.add-to-cart-container').addClass('d-none');
                    $('.step-forward-button-container').removeClass('d-none');
                    $('.step-back-button-container').removeClass('d-none');
                    $('.logo-label').removeClass('disabled');
                }

                if (data.product.promotionsHtml) {
                    $('.promotions').removeClass('d-none').html(data.product.promotionsHtml);
                } else {
                    $('.promotions').addClass('d-none').empty();
                }

                if (isEmbroidery() && $('.product-option.embroideryProductOptions .option-btn.available').length === 1 && !window.hadLogo) {
                    $('.product-option.embroideryProductOptions .option-btn.available').trigger('click');
                }
                if (isEmbroidery()) $(document).trigger('embroidery:autoStepForward');

                if (data && data.canonicalUrl) {
                    var canonicalUrl = data.canonicalUrl;
                    if (canonicalUrl.indexOf('http://') !== 0 && canonicalUrl.indexOf('https://') !== 0) {
                        canonicalUrl = window.location.origin + (canonicalUrl.indexOf('/') === 0 ? canonicalUrl : '/' + canonicalUrl);
                    }

                    var canonicalLink = document.querySelector('link[rel="canonical"]');
                    if (canonicalLink) {
                        canonicalLink.href = canonicalUrl;
                    }

                    var ogUrl = document.querySelector('meta[property="og:url"]');
                    if (ogUrl) {
                        ogUrl.setAttribute('content', canonicalUrl);
                    }
                }

                var newOgImage = null;
                if (data && data.product && data.product.images) {
                    var pdpMain = data.product.images['pdp-main-desktop'];
                    if (pdpMain && pdpMain.length && pdpMain[0].url) {
                        newOgImage = pdpMain[0].url;
                    } else {
                        var thumb = data.product.images['pdp-thumbnail-desktop'];
                        if (thumb && thumb.length && thumb[0].url) newOgImage = thumb[0].url;
                    }
                }

                if (!newOgImage && data && data.product && data.product.primaryImageUrl) {
                    newOgImage = data.product.primaryImageUrl;
                }

                if (newOgImage) {
                    var ogImgMeta = document.querySelector("meta[property='og:image']");
                    var ogImgSecure = document.querySelector("meta[property='og:image:secure_url']");

                    if (ogImgMeta) ogImgMeta.setAttribute('content', newOgImage);
                    if (ogImgSecure) ogImgSecure.setAttribute('content', newOgImage);

                    if (data.canonicalUrl && !isQuickView()) {
                        try { history.replaceState(null, '', canonicalUrl || data.canonicalUrl); } catch (e) {}
                    }
                }
            },
            complete: function () {
                if (!reinitQuickviewModalFloatImages) $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {string} pid - product id
 */
function handlePostCartAdd(response, pid) {
    var isQuickModal = isQuickView();

    if (!response.error) {
        if (!isEmbroidery()) $('.minicart').data('pid', pid);
        $('.minicart').trigger('count:update', response);

        $('body').trigger('updateCartPage', response);

        if (!response.skipShowingMinicart) {
            if (response.promoProgressBarPreAddProduct && response.promoProgressBarPreAddProduct.html) {
                if ($('.pre-add-product-promo-progress-bar-container').length > 0) {
                    $('.pre-add-product-promo-progress-bar-container').empty();
                } else {
                    $('body').append('<div class="pre-add-product-promo-progress-bar-container d-none"></div>');
                }
                $('.pre-add-product-promo-progress-bar-container').append(response.promoProgressBarPreAddProduct.html);
            }

            $('.minicart').trigger('click', { isAddToCart: true });
        }
    } else {
        $.spinner().stop();
    }
    if (!response.enabledATC) {
        $('.product-detail .quantity-select').val('1');
        $('.product-detail .quantity-select').attr('disabled', true);
    }
    $('body').trigger('product:afterAddToCart');
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else if (!isQuickModal) {
        if (!response.error) {
            if (!(isProductFinder() || isEmbroidery())) {
                $('.minicart').focusin();
                var minicartTimer = window.setTimeout(function () {
                    $('.minicart').focusout();
                }, 5000);
            }
            $('.minicart-flyout').off('mouseenter').on('mouseenter', function () {
                window.clearTimeout(minicartTimer);
            });
        }
    }
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    if ($('.add-to-cart-messages').length >= 1) {
        $('.add-to-cart-messages').remove();
    }

    if ($('.add-to-cart-messages').length === 0) {
        var container = !isQuickModal ? 'body' : '.quick-modal .modal-content';
        $(container).append(
            '<div class="add-to-cart-messages"></div>'
        );
    }

    if ($('.ats-error-alert').length >= 1) {
        $('.ats-error-alert').remove();
    }

    if (response.error && response.message) {
        if (response.atsError) {
            $('.availability-msg').append(
                '<div class="alert ' + messageType + ' ats-error-alert text-center mt-2" role="alert">'
                + response.message
                + '</div>'
            );
        } else {
            var value = isQuickModal ? 0 : $('.header-navigation').innerHeight() + $('.header-banner').innerHeight() + 'px';
            $('.add-to-cart-messages').css('top', value);
            $(window).scroll(function () {
                if (($('.add-to-basket-alert').length !== 0)) {
                    var updatedValue = $('.header-navigation').innerHeight() + $('.header-banner').innerHeight() + 'px';
                    $('.add-to-cart-messages').css('top', updatedValue);
                }
            });
            $('.add-to-cart-messages').append(
                '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
                + response.message
                + '</div>'
            );
        }
    }

    $('.add-to-basket-alert').fadeOut(3000, function () {
        $(this).remove();
        if (isQuickModal) {
            $('.quick-modal.show .modal-close-container').addClass('show');
        }
    });
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').data('product-upc'),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var isEmbroideryOption = $(this).hasClass('embroideryProductOptions');
            var embroideryValue = $productContainer.find('.embroidery').data('value-id');
            var selectedValueId;

            if (isEmbroideryOption || embroideryValue === 'yes') {
                selectedValueId = $(this).data('value-id');
            } else {
                selectedValueId = $('.option-btn', this).data('value-id');
            }

            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Get the url for the selected attribute
 * @param {string} selector - Options Selector
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {string} url - Current url
 * @return {string} url to be used for request
 */
function resetOptions(selector, $productContainer, url) {
    /* eslint-disable no-param-reassign */
    $productContainer.find(selector).each(function () {
        url = url.replace($(this).data('value-id'), $('.option-btn', this).data('value-id'));
    });
    return url;
}

/**
 * Get the url for the selected attribute
 * @param {jquery} option - Clicked attribute
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} url of the option
 */
function getUrl(option, $productContainer) {
    var url = option.attr('data-url');
    if (url && option.closest('.option-btn:not(.embroidery_yes)').length > 0 && url.indexOf('yes') > -1) {
        url = url.replace('yes', 'no');
    } else if (option.closest('.embroidery_no').length > 0) {
        if (option.closest('#editProductModal').length > 0) {
            $productContainer.find('.embroidery_no').data('url', $productContainer.find('.cancel-url').data('url'));
            url = $productContainer.find('.embroidery_no').data('url');
            var productNewURL = $('.option-btn').data('url');
            var productNewId = productNewURL.substring(productNewURL.search('pid='), productNewURL.search('&quantity'));
            productNewId = productNewId.replace('pid=', '');
            var productOldId = $('.product-options').data('product-upc') || $('.product-options').data('product-id').toString();
            url = url.split(productOldId).join(productNewId);
        } else {
            url = resetOptions('.product-option', $productContainer, url);
        }
    } else if (option.closest('.embroideryLogo').length > 0) {
        url = resetOptions('.product-option:not(.embroideryLogo)', $productContainer, url);
    }
    return url;
}

/**
 * Show options messages
 * @param {jquery} option - Clicked option
 * @param {jQuery} $productContainer - DOM container for a given product
 * @return {boolean} retrun boolean to check if there's options missed or not
 */
function validateOptions(option, $productContainer) {
    var result = false;
    if (option.hasClass('embroidery_yes')) {
        $productContainer.find('.option-error').addClass('d-none');
        var $options = $productContainer.find('.product-option');
        $options.each(function () {
            if ($(this).find('.selected').length === 0) {
                $(this).find('.option-error').removeClass('d-none');
                $productContainer.find('.embroidery').find('.option-error').removeClass('d-none');
                result = true;
            }
        });
    }
    return result;
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

function colorAttributeMouseover(attribute) {
    if ($(attribute).attr('disabled')) {
        return;
    }
    var attributeParentContainer = $(attribute).parent().prevAll('.color').length ? $(attribute).parent() : $(attribute).parent().parent();
    if (attributeParentContainer.prevAll('.color').length) {
        if ($(attribute).find('.color-value').hasClass('egift-swatch-value')) {
            attributeParentContainer.prevAll('.color:first').find('.selected-attr').html($(attribute).find('.color-value').data('attr-title').toString());
        } else {
            attributeParentContainer.prevAll('.color:first').find('.selected-attr').html($(attribute).find('.color-value').data('attr-title').toString().toUpperCase());
        }

        // show/hide new color label on mouseover
        attributeParentContainer.prevAll('.color:first').find('.new-color-text').toggleClass('d-none', !$(attribute).hasClass('is-new'));
        attributeParentContainer.prevAll('.color:first').find('.final-sale-text').toggleClass('d-none', !$(attribute).hasClass('is-final-sale'));
    }
}

function colorAttributeMouseout(attribute) {
    if ($(attribute).attr('disabled')) {
        return;
    }
    var $root = $(attribute).closest('.product-detail');
    $root.find('.color .selected-attr').html('');
    var selected = $root.find('.color-attribute.selected');
    var attributeParentContainer = $(attribute).parent().prevAll('.color').length ? $(attribute).parent() : $(attribute).parent().parent();

    if (selected.length) {
        if ($(attribute).find('.color-value').hasClass('egift-swatch-value')) {
            selected.parent().prevAll('.color:first').find('.selected-attr').html(selected.find('.color-value').data('attr-title').toString());
        } else {
            selected.parent().prevAll('.color:first').find('.selected-attr').html(selected.find('.color-value').data('attr-title').toString().toUpperCase());
            if (selected.parent().prevAll('.color:first').find('.selected-attr').length === 0) {
                selected.closest('.product-attribute').find('.selected-attr').html(selected.find('.color-value').data('attr-title').toString().toUpperCase());
            }
        }


        // show/hide new color label on mouseout
        var newColorSelectedInColorGroup = $(attribute).closest('.swatch-attribute-list').find('.color-attribute.selected.is-new').length;
        attributeParentContainer.prevAll('.color:first').find('.new-color-text').toggleClass('d-none', !newColorSelectedInColorGroup);
        attributeParentContainer.prevAll('.color:first').find('.final-sale-text').addClass('d-none');
        selected.parent().prevAll('.color:first').find('.final-sale-text').toggleClass('d-none', !selected.hasClass('is-final-sale'));
    } else {
        attributeParentContainer.prevAll('.color:first').find('.selected-attr').html('');

        // hide new color label on mouseout if no color selected
        attributeParentContainer.prevAll('.color:first').find('.new-color-text').addClass('d-none');
        attributeParentContainer.prevAll('.color:first').find('.final-sale-text').addClass('d-none');
    }
    var selectedChild = $root.find('.color-attribute .selected');
    if (selectedChild.length && selectedChild.data('attr-title')) {
        selectedChild.parent().parent().prevAll('span:first').find('.selected-attr')
            .html(selectedChild.hasClass('egift-swatch-value') ? selectedChild.data('attr-title') : selectedChild.data('attr-title').toUpperCase());
    }
}

module.exports = {
    initResizeHandlers: function () {
        if (isResizeInitialized) {
            return;
        }
        isResizeInitialized = true;
        $(window).on('resize orientationchange', function () {
            clearTimeout(resizeTimerInternal);
            resizeTimerInternal = setTimeout(resizeCarousels, 150);
        });
    },
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        },
        toggleNewColorText: toggleNewColorText,
        toggleFinalSaleText: toggleFinalSaleText
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled') || $(this).find('.swatch-value').hasClass('selected')) {
                return;
            }
            $(this).closest('.product-attribute').find('.invalidAttr').addClass('d-none');

            if ($('.embroidery-product-quickview').attr('skip-logo') === 'true') {
                $('.embroidery-product-quickview').attr('skip-logo', false);
            }

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            var url = $(this).attr('data-url');
            if (isEmbroidery() && $(this).attr('data-parent-category')) {
                url = utils.appendParamToURL(url, 'embroideryProduct', true);
            }
            if ($productContainer.find('.btn-collapse').length && !$productContainer.find('.btn-collapse').hasClass('collapsed')) {
                url = utils.appendParamToURL(url, 'isSectionOpened', true);
            }

            if ($productContainer.hasClass('product-finder-result-detail')) {
                url = utils.appendParamToURL(url, 'isProductFinder', true);
            }

            if ($('.embroidery-product-quickview').attr('selected-logo') === 'true') {
                url = utils.appendParamToURL(url, 'showLogo', true);
            }

            var colorCode = $(this).find('span').first().data('attr-value');
            if (colorCode && !(isProductFinder() || isEmbroidery())) {
                updateExplicitProductSetRecommender(colorCode);
            }

            var logoColorChange = false;
            if ($(this).hasClass('color-change')) {
                logoColorChange = true;
            }
            attributeSelect(url, $productContainer, $(this), logoColorChange); // to do
            loadZoom();
        });
    },

    setColorAttribute: function () {
        var $colorSwatch = $('.color-attribute');
        $($colorSwatch).on('mouseover', function (e) {
            e.preventDefault();
            colorAttributeMouseover(this)
        });

        $($colorSwatch).on('mouseout', function (e) {
            e.preventDefault();
            colorAttributeMouseout(this);
        });

        $(document).on('mouseover', '.quick-modal .color-attribute', function (e) {
            e.preventDefault();
            colorAttributeMouseover(this);
        });

        $(document).on('mouseout', '.quick-modal .color-attribute', function (e) {
            e.preventDefault();
            colorAttributeMouseout(this);
        });

        if ($(this).find('.swatch-item').hasClass('selected')) {
            $(this).closest('.product-attribute').find('.selected-attr').html($(this).find('.color-value').hasClass('egift-swatch-value') ? $(this).find('.color-value').data('attr-title') : $(this).find('.color-value').data('attr-title').toUpperCase())
                .removeClass('d-none');
            toggleNewColorText($(this), $(this.closest('.product-attribute').find('.new-color-text')));
            toggleFinalSaleText($(this), $(this.closest('.product-attribute').find('.final-sale-text')));
        }
    },
    swatchesAttribute: function () {
        $(document).on('click', '.attribute button:not(.color-attribute):not(.color-attribute.swatch-attribute):not(.edit-size-btn), .option-btn', function (e) {
            if ($(this).attr('disabled') || $(this).hasClass('disabled') || $(this).find('.swatch-value').hasClass('selected')) {
                return;
            }

            e.preventDefault();
            $(this).closest('.product-attribute').find('.invalidAttr').addClass('d-none');
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            var url = getUrl($(this), $productContainer);
            if (isEmbroidery() && $(this).attr('data-parent-category')) {
                url = url + '&embroideryProduct=true';
            }

            if (validateOptions($(this), $productContainer)) {
                return;
            }
            if ($productContainer.find('.btn-collapse').length && !$productContainer.find('.btn-collapse').hasClass('collapsed')) {
                url = utils.appendParamToURL(url, 'isSectionOpened', 'true');
            }

            var optionBtn = false;
            var selectedOption;
            if ($(this).closest('.logo-container').length) {
                $('.embroidery-product-quickview').attr('selected-logo', true);
            }

            if ($('.embroidery-product-quickview').attr('selected-logo') === 'true') {
                url = utils.appendParamToURL(url, 'showLogo', 'true');
            }

            // if (isEmbroidery()) {
            //     optionBtn = true;
            //     selectedOption = 'Arizona A';
            // }

            if ($(this).hasClass('option-btn')) {
                optionBtn = true;
                selectedOption = $(this).attr('data-display-value');
            }
            attributeSelect(url, $productContainer, undefined, optionBtn, selectedOption);
        });
    },
    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            var url = e.currentTarget.value;
            if ($productContainer.find('.btn-collapse').length && !$productContainer.find('.btn-collapse').hasClass('collapsed')) {
                url = utils.appendParamToURL(url, 'isSectionOpened', 'true');
            }

            attributeSelect(url, $productContainer, undefined, undefined, undefined, 'quantitySelect');
        });
    },

    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                var url = $(e.currentTarget).find('option:selected').data('url');
                if ($productContainer.find('.btn-collapse').length && !$productContainer.find('.btn-collapse').hasClass('collapsed')) {
                    url = utils.appendParamToURL(url, 'isSectionOpened', 'true');
                }
                attributeSelect(url, $productContainer, undefined, undefined, undefined, 'quantitySelect');
            }
        });
    },

    addToCart: function () {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
            e.preventDefault();
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var $customForm = null;

            $(e.target).removeClass('no-focus');

            if ($(e.target).hasClass('undo-btn')) {
                return; // Exit the handler
            }

            /* commented this code per PM-1512 : Allow customers to use special characters in gift message field */
            // var $giftMessage = $('#giftMessage');
            // if ($giftMessage.length > 0 && $giftMessage.val().trim() !== '') {
            //     // eslint-disable-next-line no-useless-escape
            //     var giftMessageRegex = new RegExp(/^[\w *;\/"%()#?.'!$,\-\n]*$/);
            //     if (!giftMessageRegex.test($giftMessage.val().trim())) {
            //         $('.invalid-feedback-gift-message').removeClass('d-none');
            //         return;
            //     }
            // }
            $('.invalid-feedback-gift-message').addClass('d-none');

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }
            $('.invalidAttr').addClass('d-none');
            var readyToOrder = true;
            var firstInvalidAttribute = null;

            // Force NVDA to announce aria-live content by clearing then re-injecting
            function showInvalidAttr($elements) {
                $elements.each(function () {
                    var $el = $(this);
                    var savedHtml = $el.html();
                    $el.removeClass('d-none').html('');
                    setTimeout(function () {
                        $el.html(savedHtml);
                    }, 50);
                });
            }

            $productContainer.find('.product-attribute').each(function () {
                if ($(this).find('.selected').length === 0) {
                    if ($(this).hasClass('e-gift-card-attribute')) {
                        var $customAmount = $productContainer.find('[id*="egiftcard-custom-amount"]');
                        if ($customAmount.length && $customAmount.val() && $customAmount.val().trim() !== '') {
                            return;
                        }
                    }
                    showInvalidAttr($(this).find('.invalidAttr'));
                    readyToOrder = false;
                    if (!firstInvalidAttribute) {
                        firstInvalidAttribute = this;
                    }
                }
            });
            if (!readyToOrder) {
                showInvalidAttr($(this).closest('.cart-and-ipay').find('.invalidAttr'));
                showInvalidAttr($('.invalid-attributes-msg').find('.invalidAttr'));
                if (firstInvalidAttribute) {
                    var buffer = 60;
                    var firstInvalidAttributeOffset = $(firstInvalidAttribute).offset().top;
                    var headerHeight = $('header').outerHeight();
                    var headerBannerHeight = Number($('.header-banner').attr('bannerHeight'));
                    var scrollPosition = firstInvalidAttributeOffset - buffer;
                    if (headerHeight) {
                        scrollPosition -= headerHeight;
                    }
                    if (headerBannerHeight && !isNaN(headerBannerHeight)) {
                        scrollPosition -= headerBannerHeight;
                    }
                    if (isQuickView()) {
                        $('.modal-content.quickview-content').scrollTop(0);
                    } else {
                        $('html, body').scrollTop(scrollPosition);
                    }
                }
                return;
            }

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find('.product-id').data('product-upc'),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            // handle the addition of custom "attributes" on the PDP
            var customFormName = $(this).data('custom-form-name');
            var customData = {};
            if (customFormName && $('form[name="' + customFormName + '"]').length) {
                // get form object
                $customForm = $('form[name="' + $(this).data('custom-form-name') + '"]');

                customData = $customForm.serializeArray().reduce(function (obj, item) {
                    obj[item.name] = item.value;
                    return obj;
                }, {});
            }

            addToCartUrl = getAddToCartUrl();
            var masterProductIDValue = $productContainer.find('[id="masterProductIDValue"]').val();
            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(this)),
                customData: JSON.stringify(customData),
                masterProductIDValue: masterProductIDValue,
                isCartPage: $('.cart-page').length > 0
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        if (data.error || !data.gtmProductDetails) {
                            handlePostCartAdd(data, pid);
                            $.spinner().stop();
                            return;
                        }
                        var gtmProductDetails = data.gtmProductDetails;
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'productAdd',
                            quantity: form.quantity,
                            master_upc: gtmProductDetails.masterProductId,
                            style_number: gtmProductDetails.manufacturerSKU,
                            upc: gtmProductDetails.variantID || '',
                            color_value: gtmProductDetails.color_value || '',
                            color: gtmProductDetails.color || '',
                            size: gtmProductDetails.size || '',
                            dmpk: gtmProductDetails.length || gtmProductDetails.inseam || gtmProductDetails.hand || gtmProductDetails.width || '',
                            collegiate: gtmProductDetails.isEmbroidered,
                            contentsquare_color_value: gtmProductDetails.contentsquare_color_value
                        });

                        $('body').trigger('product:afterAddToCartGtm', {
                            gtmProductDetails: gtmProductDetails,
                            quantity: form.quantity
                        });

                        handlePostCartAdd(data, pid);
                        miniCartReportingUrl(data.reportingURL);
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                    complete: function () {
                        // client wants focus-style removed from ATB button after it's clicked
                        setTimeout(function () {
                            $(e.target).not('no-focus').addClass('no-focus');
                        }, 500);
                    }
                });
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                    + '<div class="selected-pid row" '
                    + 'data-pid="' + pid + '"'
                    + 'data-qty="' + submittedQty + '"'
                    + 'data-optionID="' + (optionID || '') + '"'
                    + 'data-option-selected-value="' + (valueId || '') + '"'
                    + '>'
                    + '<div class="col-sm-11 col-9 bonus-product-name" >'
                    + $choiceOfBonusProduct.find('.product-name').html()
                    + '</div>'
                    + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                    + '</div>'
                    ;
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption =
                    parseInt($(this)
                        .data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.minicart-quantity').html(data.totalQty);
                        if (data.totalQty > 0) {
                            $('.minicart-quantity').removeClass('no-quantity-items');
                            $('.minicart-flyout').removeClass('empty-cart');
                        } else {
                            $('.minicart-quantity').addClass('no-quantity-items');
                            $('.minicart-flyout').addClass('empty-cart');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-success add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.msgSuccess + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                            if ($('.cart-page').length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    loadZoom: loadZoom,
    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    setSlickSlider: setSlickSlider,
    initGiftMessageCharacterCounter: giftMessage.initCharacterCounter,
    handlePDPVideo: function () {
        $(document).ready(function () {
            loadPDPVideos();
        });
    }
};

$(document).ready(function () {
    if ($('.quantity').length) {
        $(window).scroll(function () {
            var $totalheight = $('.quantity').offset();
            var $headerheight = $('header').height() - 50;
            var $actualHeight = $totalheight.top - $headerheight;

            if ($(document).scrollTop() > $actualHeight) {
                $('.fixed-add-cart-button').addClass('sticky');
                $('#launcher,#attentive_creative').addClass('sticky');

            } else {
                $('.fixed-add-cart-button').removeClass('sticky');
                $('#launcher,#attentive_creative').removeClass('sticky');
            }
        });
    }
    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
        $('.color-attribute.swatch-attribute ').addClass('safari-mac');
    }
    const $crosslist = $('.pdp-recommendations').length;
    if ($crosslist > 2) {
        $('.cross-sell-list:last-child .pdp-recommendations .collapsible-xl').removeClass('active');
        $('.cross-sell-list:last-child .pdp-recommendations .collapsible-xl .pdp-recommendations__title').attr('aria-expanded', false);
    }

    if ($('.color-attribute .selected').length) {
        $('.color-attribute .selected').parent().parent().prevAll('span:first').find('.selected-attr')
            .html($('.color-attribute .selected').hasClass('egift-swatch-value') ? $('.color-attribute .selected').data('attr-title') : $('.color-attribute .selected').data('attr-title').toUpperCase());
        toggleNewColorText($('.color-attribute.selected'), $('.color-attribute .selected').parent().parent().prevAll('span:first').find('.new-color-text'));
        toggleFinalSaleText($('.color-attribute.selected'), $('.color-attribute .selected').parent().parent().prevAll('span:first').find('.final-sale-text'));
    }

    $('.color-attribute').on('mouseover', function (e) {
        if ($(this).hasClass('unorderable')) {
            $(this).parent().prevAll('span:first').find('.selected-attr').addClass('unorder');
        } else {
            $(this).parent().prevAll('span:first').find('.selected-attr').removeClass('unorder');
        }

    });

    $('.color-attribute').on('mouseout', function (e) {
        if ($('.color-attribute.selected.unorderable').length) {
            $(this).parent().prevAll('span:first').find('.selected-attr').addClass('unorder');
        } else {
            $(this).parent().prevAll('span:first').find('.selected-attr').removeClass('unorder');
        }

    });

    $('.accordion .accordion-button').on('click', function (e) {
        e.preventDefault();

        const $button = $(this);
        const $collapse = $($button.attr('data-target'));
        const showDetails = $button.attr('data-show-details');
        const hideDetails = $button.attr('data-hide-details');

        if ($collapse.hasClass('show')) {
            $button.text(showDetails);
        } else {
            $button.text(hideDetails);
        }
    });

    $(document)
        .on('custom:finder:slick', setFinderSlickSlider)
        .on('custom:load:zoom', loadZoom)
        .on('custom:post:cart:add', function (e, data) {
            handlePostCartAdd(data.data, data.pid);
        })
        .on('custom:minicart:reporting:url', function (e, data) {
            miniCartReportingUrl(data.reportingURL);
        });

    if (isProductFinder()) {
        setFinderSlickSlider();
        loadZoom();
    }

    eGiftCard.init();
});
